export interface Moneda {
  codigo: string;
  nombre: string;
  alias: string;
}

export const monedasToSelectOptions = (monedas: Moneda[], placeholder?: string) => [
  ...(placeholder ? [{ value: '', label: placeholder }] : []),
  ...monedas.map((m) => ({ value: m.codigo, label: `${m.codigo} - ${m.alias}` })),
];
